import styled, { css } from 'styled-components';

export const CardContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
`;

export const Stat = styled.div`
    ${({ theme }) => css`
        color: ${theme.colors.tertiary.hex};
        font-weight: 900;
        margin-right: 1rem;
        line-height: 1;
        font-size: 2.75rem;
        width: 45%;
        flex: 0 0 auto;
        text-align: center;
        flex: 0 0 auto;

        @media ${theme.breakpoints.medium.media} {
            font-size: 3rem;
            width: 40%;
        }
    `}
`;

export const Text = styled.p`
    ${({ theme }) => css`
        font-size: 1rem;
        font-weight: 700;
        padding-right: 1rem;

        @media ${theme.breakpoints.smallLarge.media} {
            padding-right: 0.5rem;
            font-size: 1.25rem;
        }
    `}
`;
